const guiColors = {
    'motion-primary': 'hsla(110, 100%, 65%, 1)',
    'motion-primary-transparent': 'hsla(110, 100%, 65%, 0.9)',
    'motion-tertiary': 'hsla(110, 60%, 45%, 1)',

    'looks-secondary': 'hsla(110, 100%, 65%, 1)',
    'looks-tertiary': 'hsla(110, 60%, 45%, 1)',
    'looks-transparent': 'hsla(110, 100%, 65%, 0.35)',
    'looks-light-transparent': 'hsla(110, 100%, 65%, 0.15)',
    'looks-secondary-dark': 'hsla(110, 60%, 50%, 1)',

    'extensions-primary': 'hsla(110, 100%, 65%, 1)',
    'extensions-tertiary': 'hsla(110, 60%, 45%, 1)',
    'extensions-transparent': 'hsla(110, 100%, 65%, 0.35)',
    'extensions-light': 'hsla(110, 60%, 55%, 1)',

    'drop-highlight': 'hsla(110, 100%, 75%, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
